.button {
    align-self: end;
}
